import Vue from "vue";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, confirmed, is_not, min_value, min, max, numeric } from 'vee-validate/dist/rules';
import { phone } from 'phone';

extend('numeric', numeric);
extend('min', min);
extend('max', max);
extend('required', {
  ...required,
  message: 'The {_field_} field is required'
});
extend('min_value', min_value);
extend('email', email);
extend('confirmed', {
  ...confirmed,
  message: 'The {_field_} field does not match'
});
extend('min', {
  validate(value, { length }) {
    return value.length >= length;
  },
  params: ['length'],
  message: 'The {_field_} field must have at least {length} characters'
});
extend('is_not', is_not);
extend('ph-mobile', {
  message: 'Invalid mobile number format',
  validate(value) {
    var result = phone(value, { country: 'PHL', strictDetection: false });
    return result.isValid;
  }
});

extend('dyn-mobile', {
  validate(value, args) {
    if (!args || args.length === 0 || typeof args[0] !== 'string') {
      // If the country code argument is not provided or invalid, return false.
      console.error('Invalid or missing country code argument for dyn-mobile validation rule.');
      return false;
    }

    const countryCode = args[0];
    const result = phone(value, { country: countryCode, strictDetection: true });
    return result.isValid;
  },
  message: 'Invalid mobile number format for the selected country.',
});

extend('verify_password', {
  validate: value => {
    if(value){
      //eslint-disable-next-line
      return value.match(/[A-Z]/) && value.match(/[0-9]/) && value.match(/[a-z]/) && value.match(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) && value.length >= 8;
    } else {
      return false;
    }
  },
  message: `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character, and atleast 8 characters`
});


// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);